import { configureStore, Store } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import chatReducer from './chatSlice';
import protocolReducer from './protocolSlice';

const store: Store = configureStore({
  reducer: {
    user: userReducer,
    chat: chatReducer,
    protocols: protocolReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store; 